import { useAppContext } from '../../../context/AppContext';
import { fetchData } from '../../../services';
import { useParams, useSearchParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
export const ViewDesign = () => {
    const { token: contextToken, base_url, user, company } = useAppContext();
    const { designId } = useParams();
    const [searchParams] = useSearchParams();
    const queryToken = searchParams.get('token');
    const token = queryToken || contextToken;
    const [design, setDesign] = useState(null);
    const [viewSettings, setViewSettings] = useState(null);
    const [link, setLink] = useState("https://app.konfigear.com/mtsolar/");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Helper function to format numbers with commas
    const formatPrice = (price) => {
        return price ? price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00';
    };

    useEffect(() => {
        const loadDesign = async () => {            
            if (!token || !designId) {
                console.log('Missing token or designId:', { token: !!token, designId });
                setError('Missing authentication or design ID');
                setLoading(false);
                return;
            }
            
            try {
                setLoading(true);
                console.log(`ViewDesign - designId: ${designId}`);
                const designData = await fetchData(token, `${base_url}/apis/designs/view-design/${designId}`);
                console.log('Received design data:', designData);
                
                if (designData.design) {
                    setDesign(designData.design);
                } else {
                    console.log('No design found in response:', designData);
                    setError('Design not found');
                }

                if (designData.view_settings) {
                    setViewSettings(designData.view_settings);
                } else {
                    console.log('No view settings found in response:', designData);
                    setViewSettings({ show_pricing: false, discount: 0 });
                }
            } catch (error) {
                console.error('Error loading design:', error);
                setError(`Failed to load design: ${error.message}`);
            } finally {
                setLoading(false);
            }
        };

        loadDesign();
    }, [token, designId, base_url]);

    useEffect(() => {
        if (design && viewSettings) {
            // Generate the design link similar to Render.js
            const config = design.sky_civ_details.config;
            const frame_data = design.sky_civ_details.frame_data;
            const file_data = design.sky_civ_details.file_data;
            const design_link = `https://app.konfigear.com/mtsolar/?quote_id=${design.design_name}&user_id=1&user_email=${viewSettings.email}&sku_code=${design.unique_id}&duty_size=${config.duty_size}&pole_size=${config.pole_size}&product_type=${config.product_type}&number_of_poles=${config.number_of_poles}&pole_spacing=${config.pole_spacing}&pole_height=${config.pole_height}&wing_span=${config.wing_span}&max_foundation_depth=${config.max_foundation_depth}&tilt_angle=${frame_data.tilt_angle}&cantilever=${frame_data.cantilever}&ground_clearance=${frame_data.ground_clearance}&no_poles=${frame_data.no_poles}&module_area=${frame_data.module_area}&array_width=${frame_data.array_width}&array_height=${frame_data.array_height}&rail_length=${frame_data.rail_length}&module_length=${frame_data.module_length}&passed_overhang_check=${frame_data.passed_overhang_check}&module_width_gap=${frame_data.module_width_gap}&module_length_gap=${frame_data.module_length_gap}&total_frame_length=${frame_data.total_frame_length}&ground_to_top=${frame_data.ground_to_top}&projected_panel_height=${frame_data.projected_panel_height}&wind_speed_override=${file_data.wind_speed_override}&snow_load_override=${file_data.snow_load_override}&direct_snow_load=${file_data.direct_snow_load}&add_angle_brace=${file_data.add_angle_brace}&designer_name=${file_data.designer_name}&designer_email=${file_data.designer_email}&designer_phone=${file_data.designer_phone}&project_id=${design.project_site_id}&module_info=${file_data.module_info}&module_width=${file_data.module_width}&number_rows=${file_data.number_rows}&number_columns=${file_data.number_columns}&risk_category=${file_data.risk_category}&exposure_category=${file_data.exposure_category}&frame_duty_override=${file_data.frame_duty_override}&pole_override=${file_data.pole_override}&soil_type=${file_data.soil_type}&customer_foundation_override=${file_data.customer_foundation_override}&foundation_type=${file_data.foundation_type}&foundation_size=${file_data.foundation_size}&check_rails=${file_data.check_rails}&total_price=${design.total_design_price}&total_weight=${design.total_design_weight}&total_pallets=2&pdf=${design.sky_civ_details.pdf.pdf}&id=${design.id}`;
            setLink(design_link);
        }
    }, [design, viewSettings]);

    if (loading) {
        return (
            <div className="page">
                <div className="main-content">
                    <div className="project-header">
                        <h1>Loading Design...</h1>
                    </div>
                </div>
            </div>
        );
    }

    if (error || !design) {
        return (
            <div className="page">
                <div className="main-content">
                    <div className="project-header">
                        <h1>Error</h1>
                        <p>{error || 'Design not found'}</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="page">
            <div className="main-content">
                <div>
                    <div className="view-design-header">
                        <h1>Your New Design has been Created</h1>
                    </div>
                    <hr />
                    <div className="design-details design-details-container">
                        <div className="design-details-main">
                            <h3 className="view-design-title"><strong></strong> {design.design_name || 'N/A'}</h3>
                            <h5 className="view-design-subtitle">Project ID: {design.project_site_id}</h5>
                            <p>The MT Solar team has prepared a custom solar array design for you based on the information you provided. If you are happy with the design and would like to view full details, including an Engineering Report, please click the "Save Design to My Account" button at the top of the screen.</p>
                            
                            {/* Desktop version of the second paragraph */}
                            <p className="desktop-paragraph">This Pole Mount is designed to meet your site-specific inputs:</p>
                            
                            {/* Mobile pricing section - shows between p and ul on mobile */}
                            <div className="mobile-pricing-section">
                                {viewSettings.show_pricing && !design.is_custom && (
                                    <div className="pricing-item">
                                        <p className="text-no-margin">
                                            <strong>Price: </strong> 
                                            {design.total_design_price ? (
                                                viewSettings.discount > 0 ? (
                                                    <span>
                                                        <span className="msrp-price">
                                                            ${formatPrice(design.total_design_price)}
                                                        </span>
                                                        <span className="solar-pro-price">
                                                            ${formatPrice(design.total_design_price * (1 - viewSettings.discount / 100))}
                                                        </span>
                                                    </span>
                                                ) : (
                                                    `$${formatPrice(design.total_design_price)}`
                                                )
                                            ) : (
                                                '$$$'
                                            )}
                                        </p>
                                    </div>
                                )}
                                {user?.user_type === 'Standard' && viewSettings.show_pricing && !design.is_custom && (
                                    <>
                                        {company?.company_type === 'Property Owner' && (
                                            <div className="pricing-item">
                                                <p className="text-no-margin">
                                                    <strong>MSRP Price: </strong> 
                                                    {design.total_design_price ? (
                                                        viewSettings.discount > 0 ? (
                                                            <span>
                                                                <span className="msrp-price">
                                                                    ${formatPrice(design.total_design_price)}
                                                                </span>
                                                                <span className="solar-pro-price">
                                                                    ${formatPrice(design.total_design_price * (1 - viewSettings.discount / 100))}
                                                                </span>
                                                            </span>
                                                        ) : (
                                                            `$${formatPrice(design.total_design_price)}`
                                                        )
                                                    ) : (
                                                        '$$$'
                                                    )}
                                                </p>
                                            </div>
                                        )}
                                        {['Engineering Firm', 'Installer', 'General Contractor', 'Subcontractor'].includes(company?.company_type) && (
                                            <div className="pricing-item">
                                                <p className="text-no-margin">
                                                    <strong>Solar Pro Price: </strong>
                                                    {design.total_design_price ? (
                                                        viewSettings.discount > 0 ? (
                                                            <span>
                                                                <span className="msrp-price">
                                                                    ${formatPrice(design.total_design_price * 0.7)}
                                                                </span>
                                                                <span className="solar-pro-price">
                                                                    ${formatPrice((design.total_design_price * 0.7) * (1 - viewSettings.discount / 100))}
                                                                </span>
                                                            </span>
                                                        ) : (
                                                            `$${formatPrice(design.total_design_price * 0.7)}`
                                                        )
                                                    ) : (
                                                        '$$$'
                                                    )}
                                                </p>
                                            </div>
                                        )}
                                    </>
                                )}
                                <div className="pricing-item">
                                    <small className="text-no-margin"><strong>Weight:</strong> {design.total_design_weight ? `${design.total_design_weight.toFixed(2)} lbs` : 'XXX'}</small><br />
                                    <small className="text-no-margin"><strong>SKU:</strong> {design.unique_id || 'N/A'}</small>
                                </div>
                            </div>

                            {/* Mobile version of the second paragraph - appears just above ul on mobile */}
                            <p className="mobile-paragraph">This Pole Mount is designed to meet your site-specific inputs:</p>

                            <ul className="view-design-spec-list">
                                <li><strong>Array size:</strong> {design && design.sky_civ_details.file_data.number_rows} rows X {design && design.sky_civ_details.file_data.number_columns} cols</li>
                                <li><strong>Module size:</strong> {design && design.sky_civ_details.file_data.module_width}w X {design && design.sky_civ_details.file_data.module_length}h</li>
                                <li><strong>Number of poles:</strong> {design && design.sky_civ_details.frame_data.no_poles}</li>
                                <li><strong>Pole spacing:</strong> {design && design.sky_civ_details.config.pole_spacing}ft</li>
                                <li><strong>Ground Clearance:</strong> {design && design.sky_civ_details.frame_data.ground_clearance}ft</li>
                                <li><strong>Wind Speed Override:</strong> {design && design.sky_civ_details.file_data.wind_speed_override ? `${design.sky_civ_details.file_data.wind_speed_override} mph` : 'N/A'}</li>
                                <li><strong>Snow Load Override:</strong> {design && design.sky_civ_details.file_data.snow_load_override ? `${design.sky_civ_details.file_data.snow_load_override} psf` : 'N/A'}</li>
                            </ul>
                            <p><u><i>The 3D rendering below is interactive. Click and drag to rotate or move the design.</i></u></p>
                        </div>
                        
                        {/* Desktop pricing section - shows on the right on large screens */}
                        <div className="desktop-pricing-section">
                            {viewSettings.show_pricing && !design.is_custom && (
                                <div className="text-no-margin">
                                    <p className="text-no-margin">
                                        <strong>Price: </strong> 
                                        {design.total_design_price ? (
                                            viewSettings.discount > 0 ? (
                                                <span>
                                                    <span className="msrp-price">
                                                        ${formatPrice(design.total_design_price)}
                                                    </span>
                                                    <span className="solar-pro-price">
                                                        ${formatPrice(design.total_design_price * (1 - viewSettings.discount / 100))}
                                                    </span>
                                                </span>
                                            ) : (
                                                `$${formatPrice(design.total_design_price)}`
                                            )
                                        ) : (
                                            '$$$'
                                        )}
                                    </p>
                                </div>
                            )}
                            {user?.user_type === 'Standard' && viewSettings.show_pricing && !design.is_custom && (
                                <>
                                    {company?.company_type === 'Property Owner' && (
                                        <p className="text-no-margin">
                                            <strong>MSRP Price: </strong> 
                                            {design.total_design_price ? (
                                                viewSettings.discount > 0 ? (
                                                    <span>
                                                        <span className="msrp-price">
                                                            ${formatPrice(design.total_design_price)}
                                                        </span>
                                                        <span className="solar-pro-price">
                                                            ${formatPrice(design.total_design_price * (1 - viewSettings.discount / 100))}
                                                        </span>
                                                    </span>
                                                ) : (
                                                    `$${formatPrice(design.total_design_price)}`
                                                )
                                            ) : (
                                                '$$$'
                                            )}
                                        </p>
                                    )}
                                    {['Engineering Firm', 'Installer', 'General Contractor', 'Subcontractor'].includes(company?.company_type) && (
                                        <p className="text-no-margin">
                                            <strong>Solar Pro Price: </strong>
                                            {design.total_design_price ? (
                                                viewSettings.discount > 0 ? (
                                                    <span>
                                                        <span className="msrp-price">
                                                            ${formatPrice(design.total_design_price * 0.7)}
                                                        </span>
                                                        <span className="solar-pro-price">
                                                            ${formatPrice((design.total_design_price * 0.7) * (1 - viewSettings.discount / 100))}
                                                        </span>
                                                    </span>
                                                ) : (
                                                    `$${formatPrice(design.total_design_price * 0.7)}`
                                                )
                                            ) : (
                                                '$$$'
                                            )}
                                        </p>
                                    )}
                                </>
                            )}
                            <small className="text-no-margin"><strong>Weight:</strong> {design.total_design_weight ? `${design.total_design_weight.toFixed(2)} lbs` : 'XXX'}</small><br />
                            <small className="text-no-margin"><strong>SKU:</strong> {design.unique_id || 'N/A'}</small>
                        </div>
                    </div>
                </div>

                <div className="design-container">
                    <hr />
                    <div className="view-design-iframe-container">
                        <iframe 
                            className="view-design-iframe"
                            src={link} 
                            width="100%" 
                            height="100%" 
                            title="3D Design Model"
                        />
                        <div className="render-overlay"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};
